import React from 'react';
import Dict from '../../messages.js';
import { isTempId } from '../../utils/tempIdUtils.js';

export const MSG_ONCE_CARI_KAYDET = 'Önce cari kaydını kaydedin';

/** Cari henüz DB'de kayıtlı mı? (temp ID veya 0 ise hayır) */
export const cariKayitliMi = (ref) => ref != null && ref > 0 && !isTempId(ref);

export const MSG_ONCE_SATIS_OLUSTUR = 'Önce Satış sekmesinden satış kaydı oluşturunuz.';

/**
 * Master kayıt yoksa gösterilecek uyarı paneli.
 * Tüm master-detay sekmelerinde kullanılır (Arama, Satış, İşlem, Resim, Para, Ekim/Kanal Alım).
 * @param {object} props
 * @param {number} props.carRef - Cari referans
 * @param {string} props.sekmeAdi - Sekme başlığı (örn: "Arama İşlemleri", "Satış")
 * @param {string} props.icon - İkon emoji
 * @param {string} [props.baslik] - Opsiyonel alt başlık (varsayılan: Dict.get('Kayıt Eklenemez'))
 * @param {string} [props.mesaj] - Opsiyonel alt mesaj (varsayılan: MSG_ONCE_CARI_KAYDET; satış için MSG_ONCE_SATIS_OLUSTUR)
 */
export default function MasterKayitGerekliUyari({ carRef, sekmeAdi = 'Detay', icon = '⚠️', baslik, mesaj }) {
    return (
        <div style={{
            padding: '12px',
            background: 'var(--dx-color-bg-secondary, #f8f9fa)',
            border: '1px solid var(--dx-color-border, #dee2e6)',
            borderRadius: '4px',
            height: '100%'
        }}>
            <div style={{
                marginBottom: '8px',
                fontWeight: 'bold',
                fontSize: '14px',
                color: 'var(--dx-color-text, #212529)',
                borderBottom: '2px solid var(--dx-color-primary, #1976d2)',
                paddingBottom: '4px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}>
                <span>{icon}</span>
                <span>{sekmeAdi}</span>
            </div>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '40px 20px',
                textAlign: 'center',
                color: 'var(--dx-color-text-secondary, #6c757d)'
            }}>
                <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}>{icon}</div>
                <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                    {baslik != null ? baslik : Dict.get('Kayıt Eklenemez')}
                </div>
                <div style={{ fontSize: '14px' }}>
                    {mesaj != null ? mesaj : MSG_ONCE_CARI_KAYDET}
                </div>
            </div>
        </div>
    );
}
